import { FederationClient } from "../../client";

import { GET_RECOVERY_FLOW_CONFIG } from "./transactions.queries";

import type { IGetRecoveryFlowConfigResponseT } from "./transactions.types";
import type { GQLFetcherConfigT } from "../../../utils/types";

export async function getRecoveryFlowConfig(config?: GQLFetcherConfigT) {
  const client = FederationClient({
    cache: "no-store",
  });

  return await client.request<IGetRecoveryFlowConfigResponseT>({
    document: GET_RECOVERY_FLOW_CONFIG,
    signal: config?.signal,
  });
}
